import config from 'modules/common/config';

const AMPLITUDE_SESSION_REPLAY_ID_KEY = '[Amplitude] Session Replay ID';

export function getAmplitudeSessionReplayId(): string | undefined {
    try {
        const sr = window.sessionReplay;
        if (!sr) {
            return undefined;
        }
        const props = sr.getSessionReplayProperties?.();
        return props?.[AMPLITUDE_SESSION_REPLAY_ID_KEY] ?? undefined;
    } catch {
        return undefined;
    }
}

export function getAmplitudeSessionReplayContext():
    | { amplitude_session_replay_id: string; amplitude_session_replay_url?: string }
    | undefined {
    const replayId = getAmplitudeSessionReplayId();
    if (!replayId) {
        return undefined;
    }

    const { orgSlug, projectId } = config.amplitude;
    const encodedReplayId = encodeURIComponent(replayId);
    const replayUrl =
        orgSlug && projectId
            ? `https://app.amplitude.com/analytics/${orgSlug}/session-replay/project/${projectId}/search/replay?sessionReplayId=${encodedReplayId}`
            : undefined;

    return {
        amplitude_session_replay_id: replayId,
        ...(replayUrl && { amplitude_session_replay_url: replayUrl }),
    };
}
